import React from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { Box, CircularProgress, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { CandidatePublicProfile } from '../../components/CandidatePublicProfile'
import { useSnackbars } from '@assembly/hooks'
import { SnackbarType } from '@assembly/contexts'
import { getPublicCandidateProfile } from '@assembly/api/candidate'
import { getApiErrorMsg } from '@assembly/utils'

const LoadingBox = styled(Box)(() => ({
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}))

export default function CandidateProfile() {
    const params = useParams()
    const [searchParams] = useSearchParams()
    const { addAlert } = useSnackbars()
    const didMountRef = React.useRef<boolean>(false)
    const [data, setData] = React.useState<any>(null)
    const [isLoading, setIsLoading] = React.useState<boolean>(true)
    const [error, setError] = React.useState<string>('')

    const candidateId = params.candidate_id
    const jobId = searchParams.get('jid')

    React.useEffect(() => {
        if (!didMountRef.current) {
            getCandidateProfileAsync()
            didMountRef.current = true
        }
    }, [])

    const getCandidateProfileAsync = async () => {
        try {
            setIsLoading(true)
            const { data } = await getPublicCandidateProfile(candidateId as string, jobId || undefined)
            setData(data)
            setIsLoading(false)
        } catch (error: any) {
            setIsLoading(false)
            const errorMessage = getApiErrorMsg(error)
            setError(errorMessage)
            addAlert({
                message: errorMessage,
                type: SnackbarType.Error,
            })
        }
    }

    if (isLoading) {
        return (
            <LoadingBox>
                <CircularProgress />
            </LoadingBox>
        )
    }

    if (error || !data) {
        return (
            <LoadingBox>
                <Typography variant="h4" color="error">
                    {error || 'Candidate data not found'}
                </Typography>
            </LoadingBox>
        )
    }

    return <CandidatePublicProfile data={data} />
} 